import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { BtnComponent } from '../../components/button';
import { useGroupChatContext } from '../../context/groupchatContext';
import { chatApi, useFileUploadMutation, useGetAllProviderQuery, useGetNurseQuery, useGetProviderQuery, useSendMessageMutation } from '../../services/chatService';
import defaultStyle from '../../assets/css/mentionStyle'
import AttachmentContainer from './attachmentContainer';
import { PaperClipIcon } from '@heroicons/react/20/solid';
import { SquaresPlusIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import { forEach } from 'lodash';
import SpeechMic from '../../components/mic';
import { CheckBox } from '../../components/reactHookFormFields/checkbox';
import { useForm, useWatch } from 'react-hook-form';
import { MentionsInput, Mention } from 'react-mentions'
import MainPageDialog from '../../components/dialog';
import MarkdownToHtml from '../../components/markdownToHtml';
import DwtPopup from "../../components/dwtNew/dwtPopUp"
import ActionMenuList from '../../components/ActionMenuList';
import { HiExclamation } from "react-icons/hi";
import icClosePopup from "../../assets/images/ic-close-popup.svg";
import ReturnMessageToReply from "./returnReplyMessageWidget";
import {getNurseUrgentMsg, imageFromUuid, isPatientChatMessage, printMessage} from "../../helpers/utility";
import ShareDataFromSidePanel from "../ShareData/SareDataDialogFromSidePanel/index"
import { formattedDate } from '../../helper';
import FloatingForm from '../../components/FloatingForm';
import TaskForm from '../../components/taskForm';
import { LetterOrderDialog } from '../letters_orders';


const MessageThreadFooter = React.memo((props) => {
    const {letterOrderDialogState,setLetterOrderDialogState}=props
    const inputRef=useRef()
    const urgentMsgReminder = "If you need the immediate assistance, kindly call the provider via phone.";
    const [msgText, setMsgText] = useState('');
    const [showScannerPopup, setShowScannerPopup] = useState(false);
    const [openShareDataDialog, setOpenShareDataDialog] = useState(false);
    const [attachedFiles, setAttachedFiles] = useState([]);
    const [mentionUsers, setMentionUsers] = useState([]);
    const [taggedUsers, setTaggedUsers] = useState([]);
    const [showAcknowledgement, setShowAcknowledgement] = useState({isOpen: false});
    const textareaRef = useRef(null);
    
    const groupChatContext = useGroupChatContext();
    const {authData, selectedChat, messages, setMessages, providerUrgentMsg, selectedMessageToReply,setSelectedMessageToReply,
        isPrintMessage, selectedMessages, setIsPrintMessage, setSelectedMessages, selectedChatTab, addPendingMessage, removePendingMessage} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
        messages: groupChatContext.messages,
        setMessages: groupChatContext.setMessages,
        providerUrgentMsg: groupChatContext.providerUrgentMsg,
        selectedMessageToReply: groupChatContext.selectedMessageToReply,
        setSelectedMessageToReply: groupChatContext.setSelectedMessageToReply,
        isPrintMessage: groupChatContext.isPrintMessage,
        selectedMessages: groupChatContext.selectedMessages,
        setIsPrintMessage: groupChatContext.setIsPrintMessage,
        setSelectedMessages: groupChatContext.setSelectedMessages,
        selectedChatTab: groupChatContext.selectedChatTab,
        addPendingMessage: groupChatContext.addPendingMessage,
        removePendingMessage: groupChatContext.removePendingMessage,
    }));

    const {data: providers } = useGetProviderQuery({location_id: selectedChat?.location?.id});
    const {data: nurses } = useGetNurseQuery({location_id: selectedChat?.location?.id});

    const [getNotifyUsers] = chatApi.endpoints.getNotifyUsers.useLazyQuery();

    useEffect(()=>{
        if(providers && nurses){
            const taggedUsers = [
                ...(providers || []).map((p) => ({ ...p, id: p.user_id})),
                ...nurses
            ];
            if(taggedUsers?.length){
                setTaggedUsers(taggedUsers);
            }
        }
    }, [providers, nurses])

    const {
        control,
        getValues,
        setValue
    } = useForm();

    const {
        ...formHandler
    } = useForm();

    const {
        control: fromControl,
        setValue: fromSetValue,
        getValues: fromGetValues,
        reset: fromReset,
    } = formHandler

    const assigneeProviderVal = useWatch({ control: fromControl, name: "assignee_provider" });
    
    const [sendMessage] = useSendMessageMutation();

    const handleSendMessage = async() => {

        const is_urgent = getValues('is_urgent');
        // Remove mention user id from text
        const msgTextWithoutMentionId = msgText.replace(/\{(\d+)\}/g, "");
        const mentions = mentionUsers.map((item)=>({id: item.id, name: item.display}))
        let payload = {message: {text: msgTextWithoutMentionId, type: 'message', parent_message: selectedMessageToReply}, urgent: is_urgent,  mentions: mentions.length ? mentions : ''};

        if(isPatientChatMessage(selectedChat)){
            payload.pid = selectedChat?.pid ? selectedChat?.pid : patient.pid
        }
        else {
            payload.location_id = selectedChat?.location_id;
        }

        if(selectedMessageToReply){
            payload.parent_id = selectedMessageToReply.id;
            payload.message.parent_message = selectedMessageToReply;
        }
        if(attachedFiles.length){
            payload.message.media = attachedFiles;
            payload.is_link_to_patient_chart = 'message';
        }

        if(assigneeProviderVal?.length){
            payload.message.type = 'event';
            payload.message.event_type = 'create_task';
            const {patient, auto_complete_all} = fromGetValues();
            const groups = assigneeProviderVal.filter(item => item.type === 'task_group');
            const users = assigneeProviderVal.filter(item => item.type !== 'task_group');
            const groupUserIds = groups.flatMap(item => item.user_ids || []);
            const allUserIds = [...groupUserIds, ...users.map(item => item.value)].join(',');
            payload.message.data = {
                title: attachedFiles[0]?.title,
                auto_complete_all,
                // pid: patient?.pid,
                user_id: allUserIds,
                group_id: groups.map(item => item.group_id).join(','),
            }
        }

        payload.is_link_to_patient_chart = getValues('link_to_patient_chart');
        if (getValues('link_to_patient_chart')){
            if (payload?.message?.media?.length>0){
                payload.message.media=payload.message.media.map((item)=>({
                   ...item,
                   is_link_to_patient_chart: true,
                }))
            }
        }
        
        const tempMessageId = Date.now() + Math.random(); 
        let newMsg = {...payload, nurse_id: authData.id, user_id: authData.id, status: 'sending', temp_message_id: tempMessageId, sender: authData.is_provider ? authData.user_name : authData.name};

        const currentChat = selectedChat;
        addPendingMessage(currentChat, newMsg);

        setMessages({...messages, data: [newMsg, ...messages.data]});
        setSelectedMessageToReply(null);
        setMsgText('');
        if(payload.urgent && !authData.is_provider){
            const notifyUsers = await getNotifyUsers({type: 'sms', location_id: selectedChat?.location?.id });
            let ackMsg = notifyUsers.data?.ack_text || urgentMsgReminder;
            const notifiedProviders = notifyUsers.data?.names;
            if(notifiedProviders){
                ackMsg += '<br /> A Text will be sent to the following on call providers for this message. <br />'
                ackMsg += '<b>'+notifiedProviders+'</b>'
            }
            else{
                ackMsg += '<br />No provider will receive Text notification at the moment. <br />'
            }
            setShowAcknowledgement({isOpen: true, msg: ackMsg})
        }
        
        if (!navigator.onLine) {
            setPendingMessages(prev => [...prev, { payload, chatInfo: currentChat, tempMessageId }]);
            updateMessageStatus(tempMessageId, 'queued');
            return;
        }
        
        sendMessage(payload).then((res) => {
        
            removePendingMessage(currentChat, tempMessageId);

            setMessages(prevMessages => {
                const sendingMsg = prevMessages.data.find((msg)=> (msg.status == 'sending' && tempMessageId == msg.temp_message_id));

                if(sendingMsg){
                    let updatedMsg;
                    if(res?.data?.code === 0){
                        updatedMsg = res?.data?.data;
                    }
                    else {
                        updatedMsg = {...sendingMsg, status: 'failed'};
                        toast.error(res?.data?.msg);
                    }
                    
                    const msgs = prevMessages.data.map((msg) => 
                        (msg.status == 'sending' && tempMessageId == msg.temp_message_id) ? updatedMsg : msg
                    );
                    return {...prevMessages, data: msgs};
                }
                return prevMessages;
            });

            setAttachedFiles([]);
            setMentionUsers([]);
            setValue('is_urgent', false);
            if(res?.data?.code === 0){
                setSelectedMessageToReply(null);
            }
        }).catch((error) => {
            console.error("Error sending message:", error);
            removePendingMessage(currentChat, tempMessageId);
            setMessages(prevMessages => {
                const msgs = prevMessages.data.map((msg) => 
                    (msg.status == 'sending' && tempMessageId == msg.temp_message_id) 
                        ? {...msg, status: 'failed'} 
                        : msg
                );
                return {...prevMessages, data: msgs};
            });
            
            toast.error("Failed to send message. Please try again.");
            
            if (!navigator.onLine) {
                setPendingMessages(prev => [...prev, { payload, chatInfo: currentChat, tempMessageId }]);
                updateMessageStatus(tempMessageId, 'queued');
            } else {
                removePendingMessage(currentChat, tempMessageId);
                updateMessageStatus(tempMessageId, 'failed');
                toast.error("Failed to send message. Please try again.");
            }
        });
    };

    const onKeyDown = (e) => {
        const pressedKey = e.key;
        if (pressedKey === 'Enter' && e.shiftKey) {
            e.preventDefault();
            
            const mentionsInput = textareaRef.current;
    
            if (mentionsInput) {
                let start = mentionsInput.state.selectionStart;
                let end = mentionsInput.state.selectionEnd;
    
                // Add newline to the message text
                const newText = msgText.substring(0, start) + '\n' + msgText.substring(end);
                setMsgText(newText);
                // Move the cursor to the position after the newline character
                mentionsInput.setSelection(start + 1, start + 1);
            }
        }
    
        // When "Enter" without "Shift" is pressed
        if (pressedKey === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (msgText.trim()) {
                handleSendMessage();
            }
        }
    };

    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [pendingMessages, setPendingMessages] = useState([]);
    const isRetryingRef = useRef(false);

    
    const updateMessageStatus = useCallback((tempMessageId, status) => {
        setMessages(prevMessages => ({
            ...prevMessages,
            data: prevMessages.data.map((msg) => 
                msg.temp_message_id === tempMessageId ? {...msg, status} : msg
            )
        }));
    }, [setMessages]);

   
    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
      
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
      
        setIsOnline(navigator.onLine);
      
        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    useEffect(() => {
        if (isOnline && !isRetryingRef.current && navigator.onLine && pendingMessages.length > 0) {
            const retryPendingMessages = async () => {
                isRetryingRef.current = true;
                try {
                    const messagesToRetry = [...pendingMessages];
                    setPendingMessages([]);
                    
                    for (const pendingMsg of messagesToRetry) {
                        try {
                            updateMessageStatus(pendingMsg.tempMessageId, 'sending');
                            const response = await sendMessage(pendingMsg.payload);
                            
                            if (response?.data?.code === 0) {
                                setMessages(prevMessages => ({
                                    ...prevMessages,
                                    data: prevMessages.data.map((msg) => 
                                        msg.temp_message_id === pendingMsg.tempMessageId 
                                            ? response?.data?.data 
                                            : msg
                                    )
                                }));
                                
                                removePendingMessage(pendingMsg.chatInfo, pendingMsg.tempMessageId);
                            } else {
                                updateMessageStatus(pendingMsg.tempMessageId, 'failed');
                                toast.error(response?.data?.msg || "Failed to send message.");
                            }
                        } catch (error) {
                            console.error("Error retrying pending message:", error);
                            if (!navigator.onLine) {
                                setPendingMessages(prev => [...prev, pendingMsg]);
                                updateMessageStatus(pendingMsg.tempMessageId, 'queued');
                            } else {
                                updateMessageStatus(pendingMsg.tempMessageId, 'failed');
                                toast.error("Failed to send message. Please try again.");
                            }
                        }
                        
                        await new Promise(resolve => setTimeout(resolve, 500));
                    }
                } finally {
                    isRetryingRef.current = false;
                }
            };
            
            retryPendingMessages();
        }
    }, [isOnline, pendingMessages, sendMessage, setMessages, removePendingMessage, updateMessageStatus]);

    // const onKeyPress = (e) => {
    //     const pressedKey = e.key;
    //     console.log("e.shiftKey",e.shiftKey,"pressedKey",pressedKey);
    //     // if(pressedKey == 'Enter' && e.shiftKey){
    //     //     e.preventDefault();

    //     //     // Insert a newline character at the current cursor position
    //     //     const start = textareaRef.current.selectionStart;
    //     //     const end = textareaRef.current.selectionEnd;
    //     //     const newText = msgText.substring(0, start) + '\n' + msgText.substring(end);

    //     //     setMsgText(newText);

    //     //     // Move the cursor to the position after the newline character
    //     //     textareaRef.current.selectionStart = start + 1;
    //     //     textareaRef.current.selectionEnd = start + 1;

    //     //     // Scroll down to show the new line
    //     //     setTimeout(()=>{
    //     //         textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    //     //     }, 1)
    //     // }
    //     if(pressedKey == "Enter" && !e.shiftKey){
    //         e.preventDefault();
    //         if(msgText.trim()){
    //             handleSendMessage();
    //         }
    //     }
    // }

    const [fileUpload, { isLoading: isUploadingFile } ] =useFileUploadMutation()
    const fileUploadFunction=(formData,type)=>{
        fileUpload(formData).then((res) => {
            if(res?.data?.code === 0){
                setAttachedFiles(prevAttachment => {
                    const newArray = [...prevAttachment, res.data.data];
                    return newArray;
                });
                if (type=="scanner"){
                    setShowScannerPopup(false)
                }
            }
            else {
                toast.error(res?.data?.msg);
            }
        });
    }

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        forEach(files, (file)=>{
            const formData = new FormData();
            formData.append('file', file);
            fileUploadFunction(formData)
        })
        event.target.value = null;
    };

    useEffect(() => {
        setMsgText('');
        setAttachedFiles([]);
        formHandler.reset({
            assignee_provider: [],
            auto_complete_all: false,
        });
        textareaRef?.current?.inputElement?.focus();
    }, [selectedChat?.pid, selectedChat?.location_id]);

    useEffect(()=>{
        if(textareaRef?.current?.inputElement){
            const scrollHeight = textareaRef.current.inputElement.scrollHeight;
            if(scrollHeight < 100){
                textareaRef.current.inputElement.style.height = scrollHeight + 'px';
            }

            if(textareaRef.current.inputElement?.value?.length < 150){
                // textareaRef.current.inputElement.style.height = '2rem';
                textareaRef.current.inputElement.style.overflow = 'overlay';
            }

            textareaRef.current.inputElement.scrollTop = scrollHeight;
        }
    }, [textareaRef.current?.inputElement?.value])

    const onSpeechAvailable = (text) =>{
        const finalText = ((msgText ? msgText : '')+' '+text).trim()
        setMsgText(finalText)
    }

    const onRemoveFile = (index) => {
        setAttachedFiles(attachedFiles.filter((_, i) => i !== index))
    }

    const handleChange = (event, newValue, newPlainTextValue, mentions) => {
        setMsgText(newValue)
        setMentionUsers(mentions)
    };

    const footerListForAcknowledgement = [
        {
            title: "Acknowledged",
            type: "save",
            action: () => setShowAcknowledgement({isOpen: false}),
        }
    ]

    const [getPrintChatUuid, {isLoading: isPrintChatUuidLoading}] = chatApi.endpoints.getPrintChatUuid.useLazyQuery();

    const onPrintMessages = async() => {
        const payload = {
            message_ids: selectedMessages.join(',')
        }
        
        if(isPatientChatMessage(selectedChat)){
            payload.pid = selectedChat.pid;
        }
        else {
            payload.location_id = selectedChat.location_id;
        }

        const response = await getPrintChatUuid(payload);
        if(response?.data?.uuid){
            const url = imageFromUuid(response.data.uuid);
            setSelectedMessages([]);
            setIsPrintMessage(false);
            window.open(url, "_blank");
        }
    }

    const onPrintCancel = () =>{
        setIsPrintMessage(false);
        setSelectedMessages([]);
    }

    const [openForm, setOpenForm] = useState(false);
    const footerList = [
        {
            title: assigneeProviderVal?.length ? "Done" : "Cancel",
            type: assigneeProviderVal?.length ? "save" : "cancel",
            action: () => {
                setOpenForm(false);
            },
        },
        // {
        //     title: "Save",
        //     type: "save",
        //     action: fromHandleSubmit(onSubmitFormForm),
        // },
    ];

    if(assigneeProviderVal?.length){
        footerList.push({
            title: "Discard",
            type: "delete",
            action: () => {
                fromReset({
                    assignee_provider: [],
                    auto_complete_all: false,
                });
            },
        })
    }

    return (
        <>
            {letterOrderDialogState && 
                <LetterOrderDialog
                    letterOrderDialog={letterOrderDialogState}
                    setLetterOrderDialog={setLetterOrderDialogState}
                    attachedFiles={attachedFiles}
                    setAttachedFiles={setAttachedFiles}
                />
            }
              {openShareDataDialog && (
              <ShareDataFromSidePanel
                isLocationTab={false}
                attachDocumentHandler={(file) => {
                  setAttachedFiles((prevAttachment) => {
                    const newArray = [
                      ...prevAttachment,
                      {
                        attachment_id: file?.file_uuid,
                        size: file?.filesize,
                        mime_type: "application/pdf",
                        title: `Medical Record ${formattedDate(
                          file?.created,
                          "YYYY-MM-DD hh:mm A"
                        )}`,
                      },
                    ];
                    return newArray;
                  });
                  setOpenShareDataDialog(false);
                }}
                selectedChat={selectedChat}
                openShareDataDialog={openShareDataDialog}
                setOpenShareDataDialog={setOpenShareDataDialog}
              />
            )}
            {selectedMessageToReply && selectedMessageToReply.length != 0 && (
                <div className='p-2 bg-blue-100  border-t border-gray-200 relative'>
                    <div>
                        <h2 className=" text-sm flex justify-start font-semibold">
                            {(selectedMessageToReply.nurse_id == authData?.id || selectedMessageToReply.user_id == authData?.id)?  "You" : selectedMessageToReply?.sender}
                        </h2>
                        <div className="flex justify-between">
                            <div className="flex justify-start">
                                {/* {returnMessageWidget(selectedMessageToReply)} */}
                                <ReturnMessageToReply msg={selectedMessageToReply}/>
                                {(selectedMessageToReply?.message?.urgent || selectedMessageToReply?.urgent) && (
                                <HiExclamation title="Urgent Message" className="text-red-500 mt-1" />
                                )}
                            </div>
                            <div 
                                className='cursor-pointer border border-gray-89 hover:bg-gray-ec rounded-lg p-2 flex h-8 w-8 flex-shrink-0' 
                                onClick={() => setSelectedMessageToReply(null)}
                                role='button'
                                tabIndex={0}
                            >
                                <img 
                                    src={icClosePopup} 
                                    className="w-[14px] cursor-pointer " 
                                    
                                    style={{ visibility:'visible'}} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className='p-2 bg-white border-t border-gray-200 relative'>
                {showScannerPopup && <DwtPopup showScannerPopup={showScannerPopup} fileUploadFunction={fileUploadFunction} setFileFromScanner={setAttachedFiles} setShowScannerPopup={setShowScannerPopup} />}
                <div className="placeholder:text-black  basic-multi-select placeholder:font-normal  placeholder:text-base ui-control-input flex items-end rounded-c-full gap-3">
                    <div className="relative w-full">
                        <div className="border border-gray-300 rounded-lg p-1">
                            <AttachmentContainer data={{files: attachedFiles}} onRemoveFile={onRemoveFile} isLoading={isUploadingFile} />
                            <div className="flex items-center gap-2">
                                
                                {/* <textarea
                                    type="text"
                                    rows={Math.min(msgText.split('\n').length, 3)} // Adjust the number of rows based on the content
                                    value={msgText}
                                    ref={textareaRef}
                                    data-audio-enabled={"true"}
                                    onChange={(e)=>setMsgText(e.target.value)}
                                    onKeyPress={onKeyPress}
                                    placeholder="Type your message..."
                                    className={`flex-1 ml-2 w-full py-1 rounded-md focus:outline-none resize-none min-h-8 recorder-icon`}
                                /> */}

                                <SpeechMic transformSpeech={onSpeechAvailable} reordingControlBit={selectedChat?.pid} />

                                <MentionsInput
                                    value={msgText}
                                    ref={textareaRef} 
                                    data-audio-enabled={"true"}
                                    // className={`w-full`}
                                    className="mentions w-full focus:outline-none resize-none break-all border-none"
                                    // classNames={classNames}
                                    style={{ maxHeight: '90px', minHeight: '65px' }}

                                    // className={`w-full focus:outline-none resize-none break-all`}
                                    // style={{...defaultStyle,
                                    // }}
                                    placeholder='Type your message...'
                                    // onKeyUp={onKeyPress}
                                    onKeyDown={onKeyDown}
                                    onChange={handleChange}
                                    >
                                    <Mention
                                        appendSpaceOnAdd={true}
                                        trigger="@"
                                        markup="@[__display__]{__id__}"
                                        className="mentions__mention"
                                        // className='bg-blue-500 rounded-md text-center text-white'
                                        data={taggedUsers}
                                        renderSuggestion={(
                                            suggestion,
                                            search,
                                            highlightedDisplay,
                                            index,
                                            focused
                                        ) => (
                                            <div className=''>
                                                {highlightedDisplay}
                                            </div>
                                        )}
                                    />
                                </MentionsInput>
                            </div>
                            <div className='flex justify-end items-center gap-2 h-5'>
                                {/* <label htmlFor="fileInput" className='self-end pb-1'>
                                    <PaperClipIcon className="h-4 w-4 text-gray-400 cursor-pointer" />
                                </label> */}
                                {/* {(attachedFiles?.length && authData?.is_provider && selectedChatTab == 'patient_chat') ?
                                    <FloatingForm
                                        size="medium"
                                        isCloseOnClickOutside={true}
                                        footerList={footerList}
                                        customHeight={"min-h-[30vh]"}
                                        openForm={openForm}
                                        setOpenForm={setOpenForm}
                                        icon={<SquaresPlusIcon className={`h-6 w-6 ${assigneeProviderVal?.length ? 'text-green-700' : 'text-gray-400'} cursor-pointer`} title='Create Task'/>}
                                    >
                                        <TaskForm formHandler={formHandler} />
                                    </FloatingForm>
                                    : null
                                } */}

                                <ActionMenuList
                                    icon={<PaperClipIcon className="h-4 w-4 text-gray-400 cursor-pointer" />}
                                    title=""
                                    menuItemStyle="left-0 self-end"
                                    position='up'
                                    menuList={[
                                    {
                                        label: "Upload File",
                                        onClick: () => inputRef?.current?.click(),
                                    },
                                    {
                                        label: "Scan Document",
                                        onClick: () => {
                                        setShowScannerPopup(true)
                                        },
                                    },
                                    authData.is_provider && selectedChatTab!="location_chats" &&{
                                        label: "Share Data",
                                        onClick: () => setOpenShareDataDialog(true),
                                        },
                                    ]}
                                />
                                <input
                                    ref={inputRef}
                                    id="fileInput"
                                    type="file"
                                    className="hidden"
                                    onChange={handleFileChange}
                                    multiple
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        {isPrintMessage ?
                            <div className='flex'>
                                <BtnComponent btnType={authData.is_provider ? 'primary' : 'primary_theme'} loading={isPrintChatUuidLoading} disabled={!selectedMessages?.length} className={`p-0 items-center mt-2`} type="submit" onClick={onPrintMessages} text="Print" />
                                <div className='cursor-pointer border border-gray-89 hover:bg-gray-ec rounded-lg flex px-2 items-center mt-4 ml-2' style={{maxHeight:"5vh", minHeight: "5vh"}} onClick={onPrintCancel}>
                                    <img 
                                        src={icClosePopup} 
                                        className="w-[20px] cursor-pointer" 
                                        // onClick={onPrintCancel} 
                                        style={{ visibility:'visible'}} 

                                    />
                                </div>
                            </div>
                            :
                            <div>
                                <div className='flex flex-col gap-1 pb-2'>
                                    {attachedFiles?.length ?
                                        <CheckBox
                                            font="text-md"
                                            control={control}
                                            name="link_to_patient_chart"
                                            title="Link"
                                            toolTip="Link to patient's chart"
                                        />
                                    : null}
                                    <CheckBox
                                        font="text-md"
                                        control={control}
                                        name="is_urgent"
                                        title="Urgent"
                                    />
                                </div>
                                <BtnComponent btnType={authData.is_provider ? 'primary' : 'primary_theme'} className={`flex items-center w-full justify-center`} type="submit" disabled={!msgText.trim() && !attachedFiles?.length} onClick={handleSendMessage} text="Send" />
                            </div>
                        }
                    </div>
                </div>
                <div className='flex justify-center text-sm my-1 font-bold text-red-500 bg-yellow-200'>
                    {authData.is_provider ? providerUrgentMsg :  getNurseUrgentMsg()}
                </div>
            
                {showAcknowledgement.isOpen ? 
                    <MainPageDialog
                        title="Acknowledgement"
                        modalSize="small"
                        maxHeight={true}
                        isShowCloseBtn={false}
                        footerList={footerListForAcknowledgement}
                        onCancelHandler={() => setShowAcknowledgement({isOpen: false})}
                    >
                        <div className="text-left text-sm text-gray-900">
                            <MarkdownToHtml markdownText={showAcknowledgement.msg} />
                        </div>
                    </MainPageDialog>
                    : null
                }
            </div>
        </>
    );
});

export default MessageThreadFooter;